module.exports = __webpack_public_path__ + "fonts/comfortaa-light-webfont.b1d80af9.woff2";